import { Connection, VersionedTransaction } from '@solana/web3.js';
import { executeSolana } from './executeSolana';
import { bundle } from './jito';
import bs58 from 'bs58';
const TIMEOUT_MS = 30000; // 20 seconds timeout
async function confirmTransactionWithTimeout(connection, signature, abortSignal) {
    return new Promise((resolve, reject) => {
        const checkSignature = async () => {
            var _a, _b, _c;
            try {
                const status = await connection.getSignatureStatus(signature);
                if (((_a = status.value) === null || _a === void 0 ? void 0 : _a.confirmationStatus) === 'confirmed' ||
                    ((_b = status.value) === null || _b === void 0 ? void 0 : _b.confirmationStatus) === 'finalized' ||
                    ((_c = status.value) === null || _c === void 0 ? void 0 : _c.confirmationStatus) === 'processed') {
                    resolve();
                }
                else {
                    setTimeout(checkSignature, 500); // Check again after 1 second
                }
            }
            catch (error) {
                reject(error);
            }
        };
        abortSignal.addEventListener('abort', () => {
            reject(new Error('Transaction confirmation timed out'));
        }, { once: true });
        checkSignature();
    });
}
export async function executeDirectTransactionsSolana({ transactions, keypair, hasFeesAdded = false, waitForConfirmation = false, priorityFee, }) {
    var _a, _b, _c, _d;
    const connection = new Connection('https://mainnet.helius-rpc.com/?api-key=8bab07d6-d614-478e-ba36-c2e07ea6d720', 'confirmed');
    let result = {
        txHash: null,
        explorerUrl: null,
        txHash1: null,
        explorerUrl1: null,
        error: null,
    };
    console.log('Executing Order SOLANA, transactions:', transactions);
    console.log('Executing order priority fee 0:', priorityFee);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);
    transactions = transactions.map((txn, idx) => {
        const vTxn = VersionedTransaction.deserialize(bs58.decode(txn));
        try {
            vTxn.sign([keypair]);
            console.log('Executing Order SOLANA, after signing:', idx);
            return bs58.encode(vTxn.serialize());
        }
        catch (e) {
            console.log('Executing Order Txn signing error:', e.message, idx);
            return txn;
        }
    });
    console.log('Executing Order SOLANA, is this even logging?');
    try {
        if (transactions.length === 1) {
            console.log('Executing Order SOLANA, single transaction, about to add priority fees');
            // if (!hasFeesAdded) {
            //   transactions = await Promise.all(
            //     transactions.map(async (txn) => {
            //       try {
            //         const vTxn = await addPriorityFeesToTransaction(txn);
            //         //check txn size
            //         const size = vTxn.serialize().length;
            //         if (size >= 1232) {
            //           return txn;
            //         }
            //         vTxn.sign([keypair]);
            //         return bs58.encode(vTxn.serialize());
            //       } catch (e) {
            //         console.log('Executing Order Txn signing error after adding feeds:', e);
            //         return txn;
            //       }
            //     })
            //   );
            // }
            console.log('Executing Order SOLANA, single transaction, after adding priority fees');
            const directResultPromise = async () => {
                console.log('Executing Order is this even logging 0?');
                try {
                    return executeSolana({
                        connection,
                        transactionString: transactions === null || transactions === void 0 ? void 0 : transactions[0],
                        awaitConfirmation: false,
                    });
                }
                catch (e) {
                    console.log('Executing Order SOLANA sending direct error:', e);
                    return {
                        txHash: null,
                        error: e,
                    };
                }
            };
            const versionedTxns = transactions.map((txn) => VersionedTransaction.deserialize(bs58.decode(txn)));
            console.log('Executing Order SOLANA sending jito bundle single', versionedTxns);
            const bundleResultPromise = async () => {
                console.log('Executing Order is this even logging?');
                try {
                    return bundle(versionedTxns, keypair, connection, priorityFee);
                }
                catch (e) {
                    console.log('Executing Order SOLANA sending jito bundle single error:', e);
                    return [
                        {
                            status: 'error',
                            hash: null,
                            explorerUrl: null,
                        },
                    ];
                }
            };
            const [directResult, bundleResult] = await Promise.all([
                directResultPromise(),
                bundleResultPromise(),
            ]);
            console.log('Executing Order SOLANA jitoresults single', { bundleResult });
            const hashes = (_a = bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult.map((result) => result === null || result === void 0 ? void 0 : result.hash)) === null || _a === void 0 ? void 0 : _a.filter((hash) => hash);
            const jitoHash = hashes === null || hashes === void 0 ? void 0 : hashes[0];
            const directHash = directResult === null || directResult === void 0 ? void 0 : directResult.txHash;
            const hash = jitoHash || directHash;
            console.log('Executing Order SOLANA jito results and direct single', {
                jitoHash,
                directHash,
                directResult,
            });
            if (!hash)
                throw new Error('Transaction hash is null');
            result = {
                txHash: jitoHash,
                explorerUrl: `https://solscan.io/tx/${hash}`,
                error: null,
                bundleId: (_b = bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult[0]) === null || _b === void 0 ? void 0 : _b.bundleId,
            };
            if (waitForConfirmation) {
                await confirmTransactionWithTimeout(connection, hash, controller.signal);
            }
        }
        else {
            console.log('Executing Order SOLANA, bundle transactions');
            const versionedTxns = transactions.map((txn) => VersionedTransaction.deserialize(bs58.decode(txn)));
            // const txnSim1 = await connection.simulateTransaction(versionedTxns[0], {
            //   sigVerify: true,
            // });
            // console.log('Executing Order SOLANA, txnSim1:', txnSim1, );
            // const txnSim2 = await connection.simulateTransaction(versionedTxns[1], {
            //   sigVerify: true,
            // });
            // console.log('Executing Order SOLANA, txnSim2:', txnSim2);
            const bundleResult = await bundle(versionedTxns, keypair, connection, priorityFee);
            if (bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult.error) {
                throw new Error(bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult.error);
            }
            else {
                const hashes = (_c = bundleResult.map((result) => result === null || result === void 0 ? void 0 : result.hash)) === null || _c === void 0 ? void 0 : _c.filter((hash) => hash);
                if (waitForConfirmation) {
                    await Promise.all(hashes === null || hashes === void 0 ? void 0 : hashes.map((hash) => confirmTransactionWithTimeout(connection, hash, controller.signal)));
                }
                result = {
                    bundleId: (_d = bundleResult === null || bundleResult === void 0 ? void 0 : bundleResult[0]) === null || _d === void 0 ? void 0 : _d.bundleId,
                    txHash: hashes[0],
                    explorerUrl: `https://solscan.io/tx/${hashes[0]}`,
                    txHash1: hashes[1],
                    explorerUrl1: `https://solscan.io/tx/${hashes[1]}`,
                    error: null,
                };
                console.log('Bundle result:', bundleResult);
            }
        }
        return result;
    }
    catch (error) {
        console.log('Executing Order Error sending transactions:', error);
        if (error.name === 'AbortError') {
            throw new Error('Transaction confirmation timed out');
        }
        throw error;
    }
    finally {
        clearTimeout(timeoutId);
    }
}
